import DropdownControl from '../dropdown/DropdownControl'
import ButtonControl from '../button-control'
import DropdownTitle from '../dropdown/DropdownTitle'

function normalizePublicLabels (publicLabels, onFilterChange) {
  return publicLabels.map(publicLabel => {
    return {
      title: publicLabel,
      value: publicLabel,
      onClick: onFilterChange
    }
  })
}

const PublicLabelSelector = ({ publicLabels, selected, onFilterChange }) => {
  if (publicLabels.length === 0) {
    return
  }
  publicLabels = normalizePublicLabels(publicLabels, onFilterChange)
  return <DropdownControl
    align={'adjust'}
    trigger={<ButtonControl title={selected ? <DropdownTitle label={'Label'} title={selected} /> : 'Select a label'} class={'filter qa-label-filter'} icon={'arrowDropdown'} />}
    items={publicLabels}
  />
}

export default PublicLabelSelector
